module.exports = __webpack_public_path__ + "img/logo.d90490e9.png";